import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from '@/components/layout/Layout'
import HomePage from '@/pages/HomePage'
import PredicationsPage from '@/pages/PredicationsPage'
import PredicationDetailPage from '@/pages/PredicationDetailPage'
import PremiereVisitePage from '@/pages/PremiereVisitePage'
import AProposPage from '@/pages/AProposPage'
import ContactPage from '@/pages/ContactPage'
import { ContentProvider } from '@/content/ContentProvider'

// L'administration est chargée à part : les visiteurs ne téléchargent jamais son code.
const AdminApp = lazy(() => import('@/admin/AdminApp'))

export default function App() {
  return (
    <ContentProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="predications" element={<PredicationsPage />} />
          <Route path="predications/:id" element={<PredicationDetailPage />} />
          <Route path="premiere-visite" element={<PremiereVisitePage />} />
          <Route path="a-propos" element={<AProposPage />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>
        <Route
          path="admin/*"
          element={
            <Suspense fallback={null}>
              <AdminApp />
            </Suspense>
          }
        />
      </Routes>
    </ContentProvider>
  )
}
